import { render, staticRenderFns } from "./c-alarm-pbehavior-chip.vue?vue&type=template&id=569d0374&"
import script from "./c-alarm-pbehavior-chip.vue?vue&type=script&lang=js&"
export * from "./c-alarm-pbehavior-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports